/** Main ATS list URL. */
export function getManageCandidatesPath(): string {
  return '/manage-candidates';
}

/** Application history URL. */
export function getApplicationHistoryPath(): string {
  return '/application-history';
}

/** `pathname ===` checks and similar (no query). */
export function isManageCandidatesListPath(pathname: string): boolean {
  return pathname === getManageCandidatesPath();
}

/** Regex source for tracking (manage candidates index only). */
export function getManageCandidatesPageRegExpSource(): string {
  const base = getManageCandidatesPath();
  return `^${base}/?$`;
}
